import { createFileRoute } from "@tanstack/react-router";
import { ScreenPage } from "@/components/dashboard/screen-page";
export const Route = createFileRoute("/users")({
 head:()=>({meta:[{title:"Users — Deuxda Admin"},{name:"description",content:"Manage customer and seller accounts, roles and access."},{property:"og:title",content:"Users — Deuxda Admin"},{property:"og:description",content:"Manage customer and seller accounts, roles and access."},{property:"og:type",content:"website"},{name:"twitter:card",content:"summary_large_image"}]}),
 component:()=> <ScreenPage screen="users"/>,
});
